import * as React from 'react';
import { FlowWebContext } from './Context';
import { getConfigurationFromWindowOrDefault } from './FlowWebInternal';
export var useFlowWebContext = function useFlowWebContext() {
  var existingContext = React.useContext(FlowWebContext);
  var windowContext = getConfigurationFromWindowOrDefault();
  return existingContext || windowContext;
};